import React from "react";

function NavlogTotals({
  totalDistance,
  totalEteMin,
  totalGalsUsed,
  fuelRemaining,
  pressureAltitudeFt,
  densityAltitudeFt,
  formatTime,
  fmtFt0,
}) {
  return (
    <>
      <div className="navlog-total-container">
        <div className="navlog-total-box">
          <span>Total Distance:</span>
          <span className="navlog-total-value">
            {Number.isFinite(totalDistance) ? totalDistance.toFixed(1) : ""}
          </span>
          <span> NM</span>
        </div>

        <div className="navlog-total-box">
          <span>Total ETE:</span>
          <span className="navlog-total-value">
            {formatTime(totalEteMin)}
          </span>
          <span> Hours:Mins.</span>
        </div>

        <div className="navlog-total-box">
          <span>Total Fuel Used:</span>
          <span className="navlog-total-value">
            {Number.isFinite(totalGalsUsed) ? totalGalsUsed.toFixed(1) : ""}
          </span>
          <span> Gallons</span>
        </div>

        <div className="navlog-total-box">
          <span>Fuel Remaining:</span>
          <span className="navlog-total-value">
            {Number.isFinite(fuelRemaining) ? fuelRemaining.toFixed(1) : ""}
          </span>
          <span> Gallons</span>
        </div>
      </div>

      

        
    </>
  );
}

export default NavlogTotals;